import { icons } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { OPTION_ID_DELETE, OPTION_ID_EDIT } from "./plan.constants";
export var PLAN_BUTTON_ACTION_OPTIONS = [
    {
        icons: icons.Menu,
        id: OPTION_ID_EDIT,
        name: "editar",
    },
    {
        icons: icons.Menu,
        id: OPTION_ID_DELETE,
        name: "eliminar",
    },
];
export var EMPTY_PLAN_FORM = {
    CodePlan: "",
    Name: "",
};
